import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { Center } from '../models/center.model';
import { CenterData } from '../models/center-data.model';
import { CenterFormFilter } from '../models/center-form-filter.model';

@Injectable({
  providedIn: 'root'
})
export class CenterService {

  private apiUrl = `${environment.sgcApi}`;
  private centerRoute = 'center';

  constructor(
    private httpClient: HttpClient
  ) {}

  getCentersMap(user: string, zoneId: number) : Observable<Center[]> {
    let endpoint = `${this.apiUrl}${this.centerRoute}/user/${user}/zoneId/${zoneId}/map`;
    return this.httpClient.get<Center[]>(endpoint).pipe(map((centers) => {
      return plainToInstance(Center, centers as Center[]);
    }));
  }

  getCentersByFilter(centerFormFilter: CenterFormFilter) : Observable<CenterData[]> {
    let zoneIdParam = centerFormFilter.zoneId.toString().trim()  != "" ? centerFormFilter.zoneId.toString() : "";
    let centerCodeParam = centerFormFilter.centerCode.trim()  != "" ? centerFormFilter.centerCode : "";
    let endpoint = `${this.apiUrl}${this.centerRoute}${this.getFilters(zoneIdParam, centerCodeParam)}`;
    return this.httpClient.get<CenterData[]>(endpoint).pipe(map((centers) => {
      return plainToInstance(CenterData, centers as CenterData[]);
    }));
  }

  getCentersByUserAndExercise(user: string, exercise: number, centerFormFilter: CenterFormFilter) : Observable<Center[]> {
    let endpoint = `${this.apiUrl}${this.centerRoute}/user/${user}/exerciseId/${exercise}/map${this.getMapFilters(centerFormFilter)}`;
    return this.httpClient.get<Center[]>(endpoint).pipe(map((centers) => {
      return plainToInstance(Center, centers as Center[]);
    }));
  }

  getCenterByCenterCode(centerCode: string): Observable<CenterData> {
    let centerCodeParam = centerCode.trim()  != "" ? centerCode : "";
    let endpoint = `${this.apiUrl}${this.centerRoute}/${centerCodeParam}`;
    return this.httpClient.get<CenterData>(endpoint).pipe(map((center) => {
      return plainToInstance(CenterData, center as CenterData);
    }));
  }

  createCenter(center: CenterData, user: string) {
    let endpoint = `${this.apiUrl}${this.centerRoute}/${user}/user`;
    return  this.httpClient.post<any>(endpoint, center).pipe(
      map(data => data)
    );
  }

  updateCenter(center: CenterData, user: string) {
    let endpoint = `${this.apiUrl}${this.centerRoute}/${user}/user`;
    return  this.httpClient.put<any>(endpoint, center).pipe(
      map(data => data)
    );
  }

  private getFilters(zoneId: string, centerCode: string) {
    let urlFilter = "/?filters=";
    urlFilter += zoneId!= "" ? "zoneId=" + zoneId + ";" : "";
    urlFilter += centerCode!= "" ? "centerCode=" + centerCode + ";" : "";
    return urlFilter
  }

  private getMapFilters(centerFormFilter: CenterFormFilter) {
    let zoneId = centerFormFilter.zoneId.toString().trim()  != "" ? centerFormFilter.zoneId.toString() : "";
    let urlFilter = "?filters=";
    urlFilter += zoneId!= "" ? "zoneId=" + zoneId + ";": "";
    urlFilter += centerFormFilter.contractType != undefined ? "contractType=" + centerFormFilter.contractType : "";
    urlFilter = urlFilter.endsWith(";") ? urlFilter.slice(0, -1) : urlFilter;
    return urlFilter
  }
}
